<template>
  <div>
    <hr class="mx-2 my-4 border-slate-200 dark:border-zinc-700" />
    <MenuWrapper class="mx-2 mt-8">
      <MenuLink v-for="item in elements" :key="item.name" :href="item.href" :icon="item.icon" :hoverableTitle="!isExpanded">
        {{ item.title }}
      </MenuLink>
    </MenuWrapper>
  </div>
</template>
<script setup lang="ts">
import { MenuWrapper, MenuLink } from '@/storybook/menu';

defineProps<{ isExpanded: boolean }>();

const elements = [
  {
    title: 'Why Zight',
    name: 'why_zight',
    href: 'https://support.zight.com/hc/en-us/articles/5818788110103-What-is-Zight',
    icon: 'general.lightBulb',
  },
  {
    title: 'Use cases',
    name: 'use_cases',
    href: 'https://www.zight.com/customers/',
    icon: 'general.useCases',
  },
  {
    title: 'Pricing',
    name: 'pricing',
    href: 'https://share.zight.com/pricing',
    icon: 'general.pricing',
  },
];
</script>
